// extracted by mini-css-extract-plugin
export default {"profile":"ProfileIcon_profile__BEbWF"};